/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TumorMeasurement from './tumor-measurement';
import TumorMeasurementDetail from './tumor-measurement-detail';
import TumorMeasurementUpdate from './tumor-measurement-update';
import TumorMeasurementDeleteDialog from './tumor-measurement-delete-dialog';

const TumorMeasurementRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TumorMeasurement />} />
    <Route path="new" element={<TumorMeasurementUpdate />} />
    <Route path=":id">
      <Route index element={<TumorMeasurementDetail />} />
      <Route path="edit" element={<TumorMeasurementUpdate />} />
      <Route path="delete" element={<TumorMeasurementDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TumorMeasurementRoutes;
